const fieldsTable = [
  {
    key: "actions",
    label: "Actions"
  },
  {
    key: "hu_count",
    label: "HU COUNT"
  },
  {
    key: "dimensions",
    label: "DIMENSIONS"
  },
  {
    key: "weight",
    label: "WEIGHT"
  },
  {
    key: "contribution",
    label: "CONTRIBUTION"
  },
  {
    key: "nmfcCalculated",
    label: "NMFC CALCULATED"
  },
  {
    key: "nmfc",
    label: "NMFC"
  },
  {
    key: "description",
    label: "DESCRIPTION"
  }
];

export default fieldsTable;
